import qualityEventsHelpers from '../quality-events.helpers';
import { getCheckoutSource } from './checkout-page-quality-events';

export const THANK_YOU_PAGE_QUALITY_EVENTS = {
    purchaseBuyNow() {
        qualityEventsHelpers.track({
            type: 'purchase_buy_now'
        });
    },
    downloadPurchasedMaterial(materialId: number): Promise<void> {
        return qualityEventsHelpers.track({
            type: 'download-purchased-material-click',
            extra: JSON.stringify({
                materialId,
                source: JSON.stringify(window.location.href)
            })
        });
    },
    purchase(items: OrderItems[], details: OrderDetails) {
        const materials = items.map((item) => {
            item.material.purchase_id = details.id;
            item.material.discount = item.discount;
            item.material.finalPrice = item.finalPrice;

            return item.material;
        });

        const source = getCheckoutSource() || 'catalog';

        qualityEventsHelpers.trackMaterialList(qualityEventsHelpers.extractPurchasedMaterialsData(materials), {
            source,
            type: 'purchase',
            used_credits: Boolean(details.usedCredits)
        });
    },
    upsellingThankYouAddToCart(materials: Material | Material[], finallyCallback: () => void) {
        const extractedData = qualityEventsHelpers.extractMaterialsData(materials);

        qualityEventsHelpers
            .track(
                Array.isArray(extractedData)
                    ? extractedData.map((data) => ({ ...data, type: 'upselling-thank-you-add-to-cart' }))
                    : { ...extractedData, type: 'upselling-thank-you-add-to-cart' }
            )
            .finally(() => {
                finallyCallback();
            });
    },
    upsellingThankYouCheckboxToggle(material: Material, checked: boolean) {
        qualityEventsHelpers.track({
            ...qualityEventsHelpers.extractMaterialsData(material),
            type: checked ? 'upselling-thank-you-checkbox-check' : 'upselling-thank-you-checkbox-uncheck'
        });
    },
    aiToolsAdaptModalClosed(variant: string) {
        qualityEventsHelpers.track({
            type: 'adapt-ai-modal-closed',
            extra: variant
        });
    },
    aiToolsAdaptModalClick(variant: string) {
        qualityEventsHelpers.track({
            type: 'adapt-ai-modal-link-click',
            extra: variant
        });
    }
};
